<button [class]="type" [disabled]="disabled || loading" [ngStyle]="style" [attr.title]="title || null" type="button">
  @if (loading) {
    <span class="button-spinner" aria-hidden="true"></span>
  } @else if (icon) {
    <img [src]="icon" alt="Button Icon" />
  }
  <span>{{ label }}</span>
</button>
